<div class="summary-container">
  <div class="nav-box">
    <h2>Net Asset Value</h2>
    <p class="nav-value">{{ nav | currency:'USD':'symbol' }}</p>
  </div>

  <div class="ag-theme-alpine" style="width: 100%;">
    <ag-grid-angular class="ag-theme-alpine" style="width: 100%;" [rowData]="rowData" [columnDefs]="columnDefs"
      [defaultColDef]="defaultColDef" [autoGroupColumnDef]="autoGroupColumnDef" [groupDisplayType]="'multipleColumns'"
      [animateRows]="true" [domLayout]="'autoHeight'"
      [getRowHeight]="gridOptions.getRowHeight"
      (gridReady)="onGridReady($event)">
    </ag-grid-angular>
  </div>
</div>